import * as React from "react";
import { toINR } from "../../../service/numberFormat";
import { Link, useRouteMatch } from "react-router-dom";
import { ILimitsRouteParams } from "../../../types/components/limits/limitsTypes";

export interface ILimitsHeaderProps {
	label: string;
	value?: string;
	cshAvl?: string;
	showAddWithdrawBtn?: boolean;
}

const LimitsHeader: React.FC<ILimitsHeaderProps> = (props) => {
	const routeParams = useRouteMatch<ILimitsRouteParams>();

	return (
		<div className="limits_header">
			<div className="label">{props.label}</div>
			<div className="value">₹{toINR(props.value)}</div>
			{props.cshAvl && (
				<div className="cshAvl">
					Cash Available: <span className="cshAvl_value">₹{toINR(props.cshAvl, 2)}</span>
				</div>
			)}
			{props.showAddWithdrawBtn && (
				<div className="blue_btns">
					<Link className="blue_btn mg-r20" to={"/fund-transfer/add-funds?asset=" + (routeParams.params.asset === "equity" ? "EQ" : "CO")}>
						<i className="edel-icon-plus" />
						Add Funds
					</Link>
					<Link className="blue_btn" to={"/fund-transfer/withdraw-funds?asset=" + (routeParams.params.asset === "equity" ? "EQ" : "CO")}>
						<i className="edel-icon-download" />
						Withdraw
					</Link>
				</div>
			)}
		</div>
	);
};

export default LimitsHeader;
